import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import HomeIcon from '@material-ui/icons/Home'
import { Link, withRouter } from 'react-router-dom'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import DescriptionIcon from '@material-ui/icons/Description'
import { Heading, styles } from './styles'
import Version from '../Version'
import HeaderLogo from '../../assets/logo_sider.png'
import { Row } from 'antd'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Setting from '@material-ui/icons/Settings'
import Divider from '@material-ui/core/Divider'
import { Chip } from '@material-ui/core'
import IconInactive from '../../assets/icons/icon_inactive.png'
import IconActive from '../../assets/icons/icon_active.png'
import IconQr from '../../assets/qr_code.svg'
import { getMenu, getStatus } from '../../utils'
import { HERO_TYPE } from '../../utils/constants'

export const Sidebar = ({
  open,
  user: { name, active, tel, imageUrl, status, heroType },
  ToggleDrawer,
  location: { pathname },
  logout,
  history
}) => {
  const [collapse, setCollapse] = useState(false)

  const onClick = () => {
    setCollapse(!collapse)
  }

  return (
    <Drawer open={open} onClose={ToggleDrawer}>
      <div style={{ width: 350 }}>
        <Heading>
          <img src={HeaderLogo} alt="logo" style={{ width: '100%' }} />
        </Heading>
        <Row justify="end">
          <div style={{ padding: '5px 10px' }}>
            <Chip
              label={status}
              style={{ backgroundColor: '#6ebf4b', color: 'white' }}
            />
          </div>
        </Row>
        <Row justify="center">
          <Avatar style={styles.avatar} src={imageUrl}>
            {name && name.substring(0, 1)}
          </Avatar>
        </Row>
        <Row justify="center">
          <Typography variant="h5" style={{ color: '#6ebf4b' }}>
            {name}
          </Typography>
        </Row>
        <Row justify="center">
          <Typography variant="h6" style={{ color: '#6ebf4b' }}>
            {tel}
          </Typography>
        </Row>
        <Row justify="center" style={{ marginBottom: '10px' }}>
          {active ? (
            <Typography style={{ color: '#6ebf4b' }}>
              <img src={IconActive} alt="active" height={16} width={16} />
              {getStatus(heroType, 'open')}
            </Typography>
          ) : (
            <Typography style={{ color: 'red' }}>
              <img src={IconInactive} alt="inactive" height={16} width={16} />{' '}
              {getStatus(heroType, 'close')}
            </Typography>
          )}
        </Row>
        <Divider />
        <List>
          <ListItem
            id="menuHome"
            key="menuHome"
            button
            selected={pathname === '/'}
            onClick={ToggleDrawer}
            component={Link}
            to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="หน้าแรก" />
          </ListItem>
          <Divider />
          {heroType === 'CIRCULAR_BIN' ? (
            <ListItem
              id="menuBinAccount"
              key="menuBinAccount"
              button
              selected={pathname === '/account/bin/profile'}
              onClick={ToggleDrawer}
              component={Link}
              to="/account/bin/profile">
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary="บัญชี" />
            </ListItem>
          ) : (
            <ListItem
              id="menuAccount"
              key="menuAccount"
              button
              selected={pathname === '/account/profile'}
              onClick={ToggleDrawer}
              component={Link}
              to="/account/profile">
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary="บัญชี" />
            </ListItem>
          )}
          <Divider />
          <ListItem
            id="menuQrCode"
            key="menuQrCode"
            button
            selected={pathname === '/my-qr-code'}
            onClick={ToggleDrawer}
            component={Link}
            to="/my-qr-code">
            <ListItemIcon>
              <img src={IconQr} alt="" width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="QR Code ของฉัน" />
          </ListItem>
          <Divider />
          {heroType === 'CIRCULAR_BIN' && (
            <div>
              <ListItem
                id="menuReport"
                key="menuReport"
                button
                selected={pathname === '/report'}
                onClick={ToggleDrawer}
                component={Link}
                to="/report">
                <ListItemIcon>
                  <DescriptionIcon />
                </ListItemIcon>
                <ListItemText primary="รายงาน" />
              </ListItem>
              <Divider />
            </div>
          )}
          <ListItem button onClick={() => onClick()}>
            <ListItemIcon>
              <Setting />
            </ListItemIcon>
            <ListItemText inset primary="ตั้งค่า" />
            {collapse ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={collapse} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {heroType !== HERO_TYPE.FACTORY && (
                <ListItem
                  key="hero-setting"
                  button
                  onClick={() => {
                    history.push('/hero/setting')
                  }}>
                  <ListItemText primary={getMenu(heroType)} />
                </ListItem>
              )}
              <ListItem
                key="password"
                button
                onClick={() => {
                  history.push('/password')
                }}>
                <ListItemText primary="เปลี่ยนรหัสผ่าน" />
              </ListItem>
            </List>
          </Collapse>
          <Divider />
          <ListItem
            button
            onClick={() => {
              logout()
              history.push('/')
            }}>
            {/* <ListItemIcon /> */}
            <ListItemText inset primary="ออกจากระบบ" />
          </ListItem>
        </List>
      </div>
      <Version color="grey" logout={logout} history={history} />
    </Drawer>
  )
}

Sidebar.propTypes = {
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  ToggleDrawer: PropTypes.func.isRequired
}

export default withRouter(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js